export const routes = {
    home: '/',
    apps: '/apps',
    screens: '/screens',
    about: '/about'
}

